import { CheckpointTypeFilterType } from '@/entities/checkpoint';
import { ListAllVehiculeCheckTypeDTO } from '@/api/entities/vehicule-check-type';
import { TVehiculeCheckTypeSchema } from '@/schemas/vehicule-check-type/vehicule-check-type.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { mapCheckpointTypeFilterAPI } from '@/utils/map.utils';

const VEHICULE_CHECK_TYPE_URI = '/vehiculeCheckType';

export const createNewVehiculeCheckType = async (
  vehiculeCheckType: TVehiculeCheckTypeSchema,
) => {
  return requestApi({
    url: VEHICULE_CHECK_TYPE_URI,
    method: HTTP_METHOD.POST,
    body: vehiculeCheckType,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingVehiculeCheckType = async (
  query?: TVehiculeCheckTypeSchema,
) => {
  let url = `${VEHICULE_CHECK_TYPE_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.name) {
    params.append('name', query.name);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllVehiculeCheckTypes = async (
  query?: ListAllVehiculeCheckTypeDTO,
) => {
  let url = `${VEHICULE_CHECK_TYPE_URI}/allVehiculeCheckTypes`;
  const params = new URLSearchParams();

  if (query?.userId) {
    params.append('userId', query.userId);
  }

  if (query?.groupId) {
    params.append('groupId', query.groupId);
  }

  if (query?.personTypes) {
    query.personTypes.forEach((type) => {
      params.append('personTypes[]', type);
    });
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllVehiculeCheckTypes = async (
  filter: CheckpointTypeFilterType,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc',
) => {
  const filterMapped = mapCheckpointTypeFilterAPI(filter);

  let url = `${VEHICULE_CHECK_TYPE_URI}/all?${filterMapped}&page=${page}&limit=${limit}`;

  if (sortBy) {
    url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
  }

  return requestApi({
    url: url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveVehiculeCheckTypes = async () => {
  return requestApi({
    url: `${VEHICULE_CHECK_TYPE_URI}/totalActive`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getVehiculeCheckTypeById = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_TYPE_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

// export const getVehiculeCheckTypesByGroupId = async (groupId: string) => {
//   return requestApi({
//     url: `${VEHICULE_CHECK_TYPE_URI}/all/group/${groupId}`,
//     method: HTTP_METHOD.GET,
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   });
// };

export const getGroupVehiculeCheckType = async (groupId: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_TYPE_URI}/group/${groupId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getVehiculeCheckTypeByVehiculeCheckId = async (
  vehiculeCheckId: string,
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_TYPE_URI}/vehiculeCheck/${vehiculeCheckId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateVehiculeCheckType = async (
  vehiculeCheckType: TVehiculeCheckTypeSchema,
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_TYPE_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: vehiculeCheckType,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyVehiculeCheckTypes = async (
  vehiculeCheckTypes: TVehiculeCheckTypeSchema[],
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_TYPE_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: vehiculeCheckTypes,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
